import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../../../i18next';

import { capitalizeFirstLetter } from '../../../../../utils/CommonUtils';
import BatchUpdateContent from './BatchUpdateContent';

const BatchUpdateConfrimationScreen = props => {

    return (
        <div>
            <Modal isOpen={props.isOpen} toggle={props.onToggle}>
                <ModalHeader
                    className="modalHeader"
                    toggle={props.toggle}>{i18n.t(`screens:${props.screen}Screen.update${capitalizeFirstLetter(props.screen)}Header`)}
                </ModalHeader>

                <ModalBody>
                    
                    {props.statusChanged ? <BatchUpdateContent {...props} inputItem='active' /> : null}
                    {props.nameChanged ? <BatchUpdateContent {...props} inputItem='name' /> : null}
                    {props.descriptionChanged ? <BatchUpdateContent {...props} inputItem='description' /> : null}
                    {props.sizeChanged ? <BatchUpdateContent {...props} inputItem='size' /> : null}

                </ModalBody>

                <ModalFooter>
                    <Button
                        color="primary"
                        sm={12}
                        onClick={() => props.onSave()} >
                        <MaterialIcon icon="done" color="#fff" size={18} />
                        <span style={{ paddingLeft: 4 }}>{i18n.t('common:buttons.confirm')}</span>
                    </Button>
                    <Button outline color="primary" onClick={props.onToggle}>{i18n.t('common:buttons.cancel')}</Button>
                </ModalFooter>
            </Modal>
        </div>
    );
}

export default BatchUpdateConfrimationScreen;


// WEBPACK FOOTER //
// ./src/components/restaurants/posmenu/common/batchUpdate/BatchUpdateConfirmationScreen.js